import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import validator from 'validator';
import { backendAddress, gh_client_id, gh_redirect_url } from '../config';

export const LoginPage: React.FC = () => {

  const [failed, setFailed] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string | undefined>(undefined);

  async function handleLoginCode(code: string) {

    try {

      const response = await fetch(`${backendAddress}/login/github?code=` + code, {
        method: 'GET'
      });

      const data = await response.json();

      console.log(data);

      sessionStorage.setItem('session_id', data.sessionId);

      window.location.replace("/"); // full refresh

    } catch (error) {

      setFailed(true);

    }

  }

  useEffect(() => {

    if (location && location?.search?.includes("code")) {

      const code: string = new URLSearchParams(location.search).get("code") + '';

      if (!validator.isByteLength(code, { min: 20, max: 20 }) || !validator.isAlphanumeric(code)) {
        setFailed(true);
        setErrorMsg("something is wrong with your auth code");
        return;
      }

      handleLoginCode(code);

    } else {
      // redirect to gh oauth
      window.location.href = `https://github.com/login/oauth/authorize?client_id=${gh_client_id}&redirect_url=${gh_redirect_url}`
    }

  }, [location.search]);

  return (
    <>
      <br />
      <Container fluid>
        <Row>
          <Col xs={0} md={1} xl={2} />
          <Col xs={12} md={10} xl={8} >
            <br /><br />
            {(!failed) ? <>
              <h1 className="text-info text-center"><Spinner animation="border" /> logging in</h1>
              <h4 className="text-info text-center">please wait</h4>
            </> : <>
              <h1 className="text-danger text-center">login failed</h1>
              {(errorMsg !== undefined) && <>
                <h5 className="text-danger text-center">{errorMsg}</h5>
              </>}
              <h4 className="text-danger text-center">please retry later</h4>
            </>}
            <br />
          </Col>
          <Col xs={0} md={1} xl={2} />
        </Row>
      </Container>
    </>
  );
}
